<template lang="pug">

  main

    label.emoji_control(
      :class="{'_focus': inputFocused, '_empty': !this.inputText.length}"
    )
      .emoji_control_inner
        .emoji_control_input(
          :class="{'_hidden': inputHidden}"
        )
          textarea(
            ref="emojiInput"
            autofocus
            @focus="onInputFocus"
            @blur="onInputBlur"
            @input="onInputChange"
            @keyup="onInputKeyup"
            v-model="inputText"
          )
        .emoji_control_output
          p.emoji_control_emojis(
            ref="emojiOutput"
            @click="onEmojisClick"
            v-html="emojisText"
          )
          span.emoji_control_placeholder(
            v-if="!emojisText.length"
          )
            span(v-if="inputFocused") Type something…
            span(v-else) Type something here…
          span.emoji_control_caret


    .layout

      p.buttons

        button(
          id="copy"
          ref="copyButton"
          type="button"
          :class="{'_success': copySuccess, _fail: copyFail}"
          :disabled="copying || emojisText.length === 0"
          :aria-pressed="copying"
          @click="onCopy"
        )
          span(v-if="copySuccess") Copied!
          span(v-else-if="copyFail") Couldn’t Copy
          span(v-else) Copy it

        button(
          id="refresh"
          ref="refreshButton"
          type="button"
          :disabled="copying || emojisText.length === 0"
          @click="onRefresh"
        )
          span Change emojis

        button(
          id="clear"
          ref="clearButton"
          type="button"
          :disabled="copying || emojisText.length === 0"
          @click="onClear"
        )
          span Clear emojis

</template>
<script>
import { emojiLetters } from '@/assets/js/emojis';

export default {
  name: 'home',
  data() {
    return {
      emojisText   : '',
      inputText    : '',
      inputEmpty   : true,
      inputFocused : false,
      inputRange   : [0, 0],
      inputHidden  : true,
      copying      : false,
      copySuccess  : false,
      copyFail     : false,
    };
  },
  methods: {
    refreshEmojis() {
      this.emojisText = updateSpell(this.inputText);
    },
    onInputFocus() {
      this.inputFocused = true;
    },
    onInputBlur() {
      this.inputFocused = false;
    },
    onInputChange() {
      this.refreshEmojis();
    },
    onInputKeyup() {
      const rangeStart = this.$refs.emojiInput.selectionStart;
      const rangeEnd = this.$refs.emojiInput.selectionEnd;
      this.inputRange = [rangeStart, rangeEnd];
    },
    onEmojisClick(e) {
      // const target = e.target;
      // const index  = Array.from(target.parentNode.children).indexOf(target);
      // const input    = this.$refs.emojiInput;
      // const oldStart = this.inputRange[0];
      // const oldEnd   = this.inputRange[1];

      // let newStart = index;
      // let newEnd   = index;

      // if (target && target.classList.contains('emoji_control_output')) {
      //   let end  = input.value.length * 2;
      //   newStart = end;
      //   newEnd   = end;
      // } else if (e.shiftKey && oldStart === oldEnd) {
      //   if (oldStart > newStart) {
      //     newEnd = oldEnd;
      //   } else {
      //     newStart = oldStart;
      //   }
      // }

      // this.inputRange = [newStart, newEnd];
      // input.setSelectionRange(newStart, newEnd);
    },
    onRefresh() {
      this.refreshEmojis();
    },
    onClear() {
      this.inputText  = '';
      this.emojisText = '';
    },
    onCopy(e) {
      const that = this;
      const emojis = this.$refs.emojiOutput;

      setSelection(emojis);
      this.copying = true;

      try {
        const copied = document.execCommand('copy');
        if (copied) {
          this.copySuccess = true;
        } else {
          this.copyFail = true;
        }
      } catch (error) {
        this.copyFail = true;
      }

      clearSelection();

      setTimeout(() => {
        that.copying = false;
        that.copyFail = false;
        that.copySuccess = false;
      }, 1600);
    },
  },
};

function updateSpell(characters) {
  const chars = characters.toLowerCase();

  if (!chars.length) {
    return '';
  }

  let output = '<span class="word">';

  for (let i = 0, len = chars.length; i < len; i++) {
    // 4 Letters
    if (chars[i + 3]) {
      const part = chars.slice(i, i + 4);

      if (emojiLetters[part]) {
        output += '<span class="emoji">' + emojiLetters[part][0] + '</span>';
        i += 3;
        continue;
      }
    }

    // 3 Letters
    if (chars[i + 2]) {
      const part = chars.slice(i, i + 3);

      if (emojiLetters[part]) {
        output += '<span class="emoji">' + emojiLetters[part][0] + '</span>';
        i += 2;
        continue;
      }
    }

    // 2 Letters
    if (chars[i + 1]) {
      const part = chars.slice(i, i + 2);

      if (emojiLetters[part]) {
        output += '<span class="emoji">' + emojiLetters[part][0] + '</span>';
        i += 1;
        continue;
      }
    }

    if (emojiLetters[chars[i]]) {
      const letter = emojiLetters[chars[i]];
      let emoji = letter[0];

      if (letter.length > 1) {
        emoji = letter[Math.floor(Math.random() * letter.length)];
      }

      output += '<span class="emoji">' + emoji + '</span>';
    } else if (chars[i] === ' ') {
      output += '</span><span class="space">&emsp;</span><span class="word">';
    }
  }

  output += '<span class="word">';
  return output;
}

function setSelection(el) {
  const selection = window.getSelection();
  const range = document.createRange();
  range.selectNodeContents(el);
  selection.removeAllRanges();
  selection.addRange(range);
}

function clearSelection() {
  window.getSelection().removeAllRanges();
}

</script>
